import { render, staticRenderFns } from "./ResourceCommonModal.vue?vue&type=template&id=d79fc5e6&"
import script from "./ResourceCommonModal.vue?vue&type=script&lang=js&"
export * from "./ResourceCommonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports